import React, { ReactNode, createContext, useContext, useState } from 'react';

// Set this to true to enable prelaunch mode, false to disable
const IS_PRELAUNCH_MODE = false; 

interface PrelaunchContextType {
  isPrelaunch: boolean;
}

const PrelaunchContext = createContext<PrelaunchContextType | undefined>(undefined);

export const usePrelaunch = (): PrelaunchContextType => {
  const context = useContext(PrelaunchContext);
  if (!context) {
    throw new Error('usePrelaunch must be used within a PrelaunchProvider');
  }
  return context;
};

interface PrelaunchProviderProps {
  children: ReactNode;
}

export const PrelaunchProvider: React.FC<PrelaunchProviderProps> = ({ children }) => {
  const [isPrelaunch] = useState<boolean>(IS_PRELAUNCH_MODE);

  return (
    <PrelaunchContext.Provider value={{ isPrelaunch }}>
      {children}
    </PrelaunchContext.Provider>
  );
}; 